$(function() {
    // Open mobile menu

    $('.mobile-menu-btn').on('click', function(e) {
        e.preventDefault();

        if ($(this).hasClass('open') === true) {
            setTimeout(function() {
                $('body, .page-header').toggleClass('overflow');
            }, 1000);
        } else {
            $('body, .page-header').toggleClass('overflow');
        }

        $(this).toggleClass('open').siblings('.main-menu').toggleClass('open');

        $('.global-overlay').toggleClass('show');
    });

    $('.global-overlay').on('click', function() {
        $(this).removeClass('show');

        $('.mobile-menu-btn').removeClass('open').siblings('.main-menu').removeClass('open');

        setTimeout(function() {
            $('body, .page-header').removeClass('overflow');
        }, 1000);
    });

    // Open drop down in mobile header

    if ($(window).width() > 1024) {
        $('.has-dd').on('mouseenter', function() {
            $('.global-overlay').addClass('show');
        }).on('mouseleave', function() {
            $('.global-overlay').removeClass('show');
        });
    } else {
        $('.has-dd').on('click', function() {
            $(this).toggleClass('active');
        });
    }
});